var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogovertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.717,
    height: 252.644,
    viewBox: "0 0 162.717 252.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(-1143.283 -939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M1047.01,44.844c-2.8-5.1-6.1-10.1-10.7-13.8a22.153,22.153,0,0,0-18-5,29.625,29.625,0,0,0-9.1,3.5c-2.2,1.2-4.3,2.5-6.5,3.8-.9.5-1.9,1.1-2.8,1.6a.367.367,0,0,1-.3.1,2.507,2.507,0,0,0-.7.4,13.423,13.423,0,0,1-12.6-.8c-.1-.1-.2-.1-.3-.2-2.8-1.6-5.6-3.3-8.4-4.9a30.632,30.632,0,0,0-9.1-3.5c-6.5-1.2-13,1-18,5a45.346,45.346,0,0,0-10.7,13.8c-3.1,5.6-5.7,11.7-5.6,18,.1,6.4,3.4,13,9.3,15.4a17.885,17.885,0,0,0,10.5.6c12.9-2.4,23.6-11.9,36.8-13.5.3,0,.6-.1.9-.1h.2a25.551,25.551,0,0,1,6.2.4c12.3,2.2,22.5,10.9,34.8,13.2a19.678,19.678,0,0,0,10.5-.6c5.9-2.4,9.2-9.1,9.3-15.4C1052.71,56.444,1050.11,50.344,1047.01,44.844Zm-84.6,17.5a10.35,10.35,0,0,1-10.3-10.3,10.3,10.3,0,1,1,20.6.1A10.137,10.137,0,0,1,962.407,62.344Zm76.6,1.1a4.157,4.157,0,0,1-6.8,1.1l-6-6c-.4-.4-.8-.4-1.1,0l-5.1,5.4a4.248,4.248,0,0,1-5.9.4,4.061,4.061,0,0,1-.4-5.9c1.8-1.9,3.7-3.7,5.5-5.5.6-.6.5-.8-.1-1.4-2-2-4.1-4-6.1-6.1a3.918,3.918,0,0,1-.1-5c.9-1.2,3.1-2.2,4.7-1.3a7.183,7.183,0,0,1,2,1.4c1.8,1.7,3.5,3.4,5.2,5.2.7.7.8.6,1.5-.1,2.1-2.1,4.1-4.3,6.3-6.2a3.988,3.988,0,0,1,6.4,2c.1.4.1.7.2,1.1a4.572,4.572,0,0,1-1.3,3.1c-1.9,2-3.8,3.9-5.8,5.9-.7.7-.6.9.1,1.5,1.2,1.1,2.4,2.3,3.6,3.5.9.9,1.8,1.8,2.7,2.8A3.621,3.621,0,0,1,1039.01,63.444Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M924.007,33.544a21.72,21.72,0,0,1,4.2-13.3c3.7-4.8,10.5-9,16.6-6.7a4.036,4.036,0,0,1,2.7,2.4,2.8,2.8,0,0,1-.2,2.2c-.7,1.5-14.9,21.1-16.1,22.5-.8,1-1.9,2-3.4,1.6a3.407,3.407,0,0,1-2.6-2.2A17.1,17.1,0,0,1,924.007,33.544Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M929.007,79.344c-2,.1-4.1-.7-4.8-2.9a3.648,3.648,0,0,1,.8-3.6,6.438,6.438,0,0,1,3.8-2,5.972,5.972,0,0,1,3.5.1,4.135,4.135,0,0,1,2.5,3.2,4.072,4.072,0,0,1-1.9,4,11.175,11.175,0,0,1-2.5,1.1C930.007,79.244,929.507,79.344,929.007,79.344Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M937.707,81.144h.2a3.551,3.551,0,0,1,2.7,1.5,4.439,4.439,0,0,1,1,2.2,5.688,5.688,0,0,1-.9,3.3,8.33,8.33,0,0,1-2,2.2,3.522,3.522,0,0,1-2.8.7,4.44,4.44,0,0,1-2.2-1,4.069,4.069,0,0,1-1.3-1.9,5.036,5.036,0,0,1,.4-3.2,8.6,8.6,0,0,1,2-2.6A5.322,5.322,0,0,1,937.707,81.144Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M928.207,65.744a5.677,5.677,0,0,1-4.3-2,3.522,3.522,0,0,1-.6-3.9,3.912,3.912,0,0,1,3.3-2.5,5.03,5.03,0,0,1,4.8,2,3.64,3.64,0,0,1,.6,4.1A3.928,3.928,0,0,1,928.207,65.744Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M1062.81,33.544a21.72,21.72,0,0,0-4.2-13.3c-3.7-4.8-10.5-9-16.6-6.7a4.036,4.036,0,0,0-2.7,2.4,2.794,2.794,0,0,0,.2,2.2c.7,1.5,14.9,21.1,16.1,22.5.8,1,1.9,2,3.4,1.6a3.407,3.407,0,0,0,2.6-2.2A17.094,17.094,0,0,0,1062.81,33.544Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M1057.81,79.344c2,.1,4.1-.7,4.8-2.9a3.648,3.648,0,0,0-.8-3.6,6.438,6.438,0,0,0-3.8-2,5.972,5.972,0,0,0-3.5.1,4.135,4.135,0,0,0-2.5,3.2,4.072,4.072,0,0,0,1.9,4,11.174,11.174,0,0,0,2.5,1.1C1056.81,79.244,1057.31,79.344,1057.81,79.344Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M1049.11,81.144h-.2a3.552,3.552,0,0,0-2.7,1.5,4.44,4.44,0,0,0-1,2.2,5.688,5.688,0,0,0,.9,3.3,8.332,8.332,0,0,0,2,2.2,3.522,3.522,0,0,0,2.8.7,4.44,4.44,0,0,0,2.2-1,4.07,4.07,0,0,0,1.3-1.9,5.036,5.036,0,0,0-.4-3.2,8.6,8.6,0,0,0-2-2.6A5.322,5.322,0,0,0,1049.11,81.144Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M1058.61,65.744a5.677,5.677,0,0,0,4.3-2,3.522,3.522,0,0,0,.6-3.9,3.913,3.913,0,0,0-3.3-2.5,5.03,5.03,0,0,0-4.8,2,3.64,3.64,0,0,0-.6,4.1A3.928,3.928,0,0,0,1058.61,65.744Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M987.307,26.444a4.107,4.107,0,0,1-5.7-1.5l-3.8-6.6a4.168,4.168,0,0,1,7.2-4.2l3.8,6.6A4.067,4.067,0,0,1,987.307,26.444Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M999.507,26.444a4.11,4.11,0,0,0,5.7-1.5l3.8-6.6a4.168,4.168,0,0,0-7.2-4.2l-3.8,6.6A4.151,4.151,0,0,0,999.507,26.444Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M1074.61,34.744a34.539,34.539,0,0,0-2.5-16.2,29.633,29.633,0,0,0-19.9-16.9c-8.9-2.3-17.7-.1-26.4,2.1-.5.1-.9.4-1.4.5-1.5.3-3.5-.7-5-1.1-2-.5-4.1-1-6.1-1.3a104.167,104.167,0,0,0-12.5-1.6c-1.9-.1-3.7-.2-5.5-.2-1.9-.1-3.7,0-5.4,0-1.4,0-2.7.1-4.1.2-.5,0-1.1.1-1.6.1h-.2c-3.6.3-7.1.8-10.6,1.4-2.1.4-4.1.8-6.1,1.3-1.5.4-3.5,1.4-5,1.1-.5-.1-.9-.4-1.4-.5-8.7-2.1-17.4-4.3-26.4-2.1a30.067,30.067,0,0,0-19.9,16.9,34.54,34.54,0,0,0-2.5,16.2,44.065,44.065,0,0,0,1.7,9.5c.5,1.8,3,6.2,2.1,7.9-6,12.3-2.4,26.9,4.2,38.2a76.755,76.755,0,0,0,33.1,30.2c19.3,9.3,42.1,11.1,62.8,6.2a84.8,84.8,0,0,0,17.5-6.2,77.314,77.314,0,0,0,33.1-30.2c6.5-11.3,10.2-25.9,4.2-38.2-.8-1.7,1.7-6.1,2.1-7.9A57.745,57.745,0,0,0,1074.61,34.744Zm-9,4.6c-1,4.7-2.6,9.3-2.3,14.1.2,3.5,1.5,6.9,2,10.3,1,6.8-1.2,13.7-4.3,19.7a67.559,67.559,0,0,1-28.7,28.3,82.023,82.023,0,0,1-29.9,8.8h-1.5c-1.6,0-3.2.1-4.8.2h-5.4c-2.1,0-4.3-.1-6.4-.2a81.521,81.521,0,0,1-29.8-8.8,68.123,68.123,0,0,1-28.7-28.3c-3.1-6.1-5.3-13-4.3-19.7.5-3.5,1.8-6.8,2-10.3.3-4.8-1.3-9.4-2.3-14.1-1.1-5.3-1.4-10.9.4-16.1a21.676,21.676,0,0,1,16.4-14c5.9-1,11.9.5,17.7,1.5a52.651,52.651,0,0,0,8.9.9c2.7-.1,5.2-1.1,7.9-1.6l3.9-.7a105.667,105.667,0,0,1,14.9-1.2h4.1a97.326,97.326,0,0,1,15.2,1.2l3.9.7c2.6.5,5.2,1.6,7.9,1.6a38.429,38.429,0,0,0,8.9-.9c5.8-1,11.8-2.5,17.7-1.5a21.676,21.676,0,0,1,16.4,14C1067.01,28.444,1066.71,34.044,1065.61,39.344Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M1018.21,84.044a4.237,4.237,0,0,0-3.3-2.9,3.811,3.811,0,0,0-3.8,1.6c-.3.4-.5.9-.8,1.3-.6.8-1.1,1.7-1.7,2.4a5.213,5.213,0,0,1-5,1.5,22.024,22.024,0,0,1-5.6-2c-.1-.1-.3-.1-.4-.2h-.1a1.69,1.69,0,0,0-.5-.2c-.1,0-.2-.1-.3-.1-.2-.1-.3-.1-.5-.2s-.4-.1-.6-.2h-.1a9.038,9.038,0,0,0-5.6.5c-.1,0-.2.1-.3.1s-.2.1-.3.1c-.1.1-.3.1-.4.2a20.5,20.5,0,0,1-4.1,1.6h-.1c-.5.1-.9.2-1.4.3a4.872,4.872,0,0,1-5-1.5,13.086,13.086,0,0,1-1.7-2.4c-.3-.4-.5-.9-.8-1.3a3.811,3.811,0,0,0-3.8-1.6,3.969,3.969,0,0,0-3.3,2.9c-1,2.8,1.5,6.2,3.4,8.1a14.628,14.628,0,0,0,7.3,4,14.229,14.229,0,0,0,7.1-.4h.1a19.708,19.708,0,0,0,6.2-2.5,1.049,1.049,0,0,1,1.3,0,21.069,21.069,0,0,0,6.5,2.6,15.127,15.127,0,0,0,7,.4,14.628,14.628,0,0,0,7.3-4C1016.71,90.244,1019.21,86.844,1018.21,84.044Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M1002.61,75.344a4.4,4.4,0,0,0-1.8-4.3c-.1,0-.1-.1-.2-.1a.1.1,0,0,1-.1-.1,9.49,9.49,0,0,0-2.2-1.2c-.2-.1-.3-.1-.5-.2-.1,0-.1,0-.2-.1a18.007,18.007,0,0,0-3.8-.7,10.868,10.868,0,0,0-1.8.1,11.884,11.884,0,0,0-5.9,2,5.211,5.211,0,0,0-1.7,2,4.036,4.036,0,0,0,1.8,5.4c1.5.9,3.1,1.6,4.7,2.4a5.419,5.419,0,0,0,3.5.4h.1a.368.368,0,0,0,.3-.1c.1,0,.2-.1.3-.1.3-.1.5-.2.8-.3a37.065,37.065,0,0,0,4.4-2.3c.2-.1.4-.3.6-.4A3.007,3.007,0,0,0,1002.61,75.344Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M946.807,182.445c0,9.2-4.1,15.5-15.2,15.4h-17.2v-41.2a16.772,16.772,0,0,1,16.8-16.8h.3c11.8,0,15.1,5.9,15.1,14.8,0,8-1.2,13.3-8.1,13.3,7.1.8,8.3,7.1,8.3,12.8Zm-14-26.6c0-7.1-.6-7.6-2.9-7.6a2.22,2.22,0,0,0-2.2,2.2v13.4h2.1c1.7,0,3-.3,3-5.4Zm.4,23.3c0-5.8-.7-6.9-3.4-6.9h-2.1v17.2h2.4c2,0,3.1-1,3.1-5.4Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M975.307,197.844h-23v-58h13.4v49.6h9.7v8.4Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M979.407,197.844v-58h13.5v58Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M1019.61,197.844l-9.9-34.9v34.9h-10.3v-58h14.3l9.5,34v-34h10.2v58Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M1072.41,181.745c0,9.2-4,16.1-15.1,16.1h-17.3v-58h17.3c11,0,15.1,7.1,15.1,16.1Zm-13.3-25.8c0-7.1-.5-7.9-3.9-7.9h-1.9v41.4h1.9c2.8,0,3.9-1,3.9-7.7Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M925.507,211.344v12.8h7.2v7h-7.2v21.4h-11.1v-39.2a9.132,9.132,0,0,1,9.1-9.1h11.3v7h-9.3Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M938.107,252.644v-48.3h21v7h-9.8v12.8h7.7v7h-7.7v14.4h9.8v7h-21Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M978.807,252.644l-3.5-21.7v-4.9h.7c1.3,0,2.1-1,2.1-5.2v-3.2c0-5.9-.5-6.2-2.9-6.2h-1.3v41.2h-11.1v-48.3h14.3c8.6,0,12.7,4.2,12.7,12.2v2.7c0,8.4-1.1,10.6-5,11.9l6.6,21.5Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M1010.31,252.644l-3.5-21.7v-4.9h.7c1.3,0,2.1-1,2.1-5.2v-3.2c0-5.9-.5-6.2-2.9-6.2h-1.3v41.2h-11.1v-48.3h14.3c8.6,0,12.7,4.2,12.7,12.2v2.7c0,8.4-1.1,10.6-5,11.9l6.6,21.5Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M1072.41,211.445h-6.6v41.2h-11.1v-41.2h-17.8v12.7h7.7v7h-7.7v14.4h9.8v7h-21v-48.3h39.6A7.349,7.349,0,0,1,1072.41,211.445Z",
    transform: "translate(231.283 939)",
    fill: "#fec260"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogovertical);
export default __webpack_public_path__ + "static/media/logovertical.a1da853228d84a967a7e3f7ed8ca6d38.svg";
export { ForwardRef as ReactComponent };